import Hero from "@/components/home/Hero";
import RipeNowStrip from "@/components/home/RipeNowStrip";
import Philosophy from "@/components/home/Philosophy";
import CategoryRail from "@/components/home/CategoryRail";
import SeasonEditorial from "@/components/home/SeasonEditorial";
import StoreExperience from "@/components/home/StoreExperience";
import FranchiseTeaser from "@/components/home/FranchiseTeaser";
import StoreFinder from "@/components/home/StoreFinder";
import SocialSection from "@/components/home/SocialSection";
import Marquee from "@/components/Marquee";
import LeadForm from "@/components/LeadForm";
import { Reveal } from "@/components/Reveal";
import { useSeo } from "@/lib/seo";

export default function Home() {
  useSeo({
    title: "RIFIC | Real Tastes Better — Premium Ice Cream, Desserts & Shakes",
    description:
      "RIFIC is a premium Indian ice cream brand built on real fruit, real milk and real ingredients. Explore the menu, the RIPE NOW seasonal platform, our bold orange stores — and own a RIFIC franchise.",
    path: "/",
    image: "https://rific.in/images/store1.webp",
  });

  return (
    <div data-testid="home-page">
      <Hero />
      <Marquee
        className="bg-orange-rific py-4 text-deep md:py-5"
        textClassName="font-display text-xl md:text-3xl font-semibold uppercase tracking-wide"
        items={["WE PICK IT RIPE.", "WE MAKE IT RIFIC.", "WE PICK IT RIPE.", "WE MAKE IT RIFIC."]}
      />
      <RipeNowStrip />
      <Philosophy />
      <CategoryRail />
      <SeasonEditorial />
      <StoreExperience />
      <FranchiseTeaser />

      <section id="franchise-form" className="scroll-mt-20 bg-cream py-16 md:py-24" data-testid="home-lead-form-section">
        <div className="mx-auto max-w-[1440px] px-5 md:px-10">
          <Reveal>
            <p className="font-mono text-[11px] uppercase tracking-[0.28em] text-orange-rific md:text-xs">Franchise Enquiry</p>
            <h2 className="mt-3 font-display text-[clamp(2rem,4.2vw,3.25rem)] font-extrabold tracking-[-0.01em] text-deep">
              START THE CONVERSATION.
            </h2>
            <p className="mt-4 max-w-2xl text-base leading-relaxed text-deep/70 md:text-lg">
              Tell us about your city and your ambition. Our franchise team will take it from there.
            </p>
          </Reveal>
          <Reveal delay={0.1} className="mt-10 md:mt-14">
            <LeadForm />
          </Reveal>
        </div>
      </section>

      <StoreFinder limit={3} />
      <SocialSection />
    </div>
  );
}
